import React from "react";

const AuthWarning = (props: any) => {
	return (
    <div className="grid-container">
      <div className="callout tertiary round">
        <p>Трябва да си логнат за да ползваш тази функционалност. Можеш да влезеш в профила си или да се регистрираш тук: </p>
        <a href={`/users/sign_in?redirect=${window.location.pathname}`} className="button hollow">Вход/Регистрация</a>
      </div>
    </div>
	)
}

export default AuthWarning;